































import { Component, Prop, Vue } from 'vue-property-decorator';
import { Button, Dropdown, DropdownItem, DropdownMenu } from 'element-ui';
import ChannelSelectItem from '@/components/channel/ChannelSelectItem.vue';
import Avatar from '@/components/Avatar.vue';
import {
  ChannelFields,
  ChannelMessageFields,
  CustomerOrganizationFields,
  SenderFields
} from '@/types/graphql/schemaTypes';

@Component({
  components: {
    Avatar,
    ChannelSelectItem,
    'el-button': Button,
    'el-dropdown': Dropdown,
    'el-dropdown-item': DropdownItem,
    'el-dropdown-menu': DropdownMenu
  }
})
export default class ChannelSelect extends Vue {
  @Prop({ default: () => { return []; }, required: true, type: Array }) channels!: ChannelFields[];
  @Prop({ required: true, type: Object }) organization!: CustomerOrganizationFields;

  private get channelList(): ChannelFields[] {
    return this.channels;
  }

  mounted() {
    this.$root.$on('channelMessageCreated', this.updateChannelMessage);
  }

  destroyed() {
    this.$root.$off('channelMessageCreated', this.updateChannelMessage);
  }

  private getAvatarUrl(sender: SenderFields) {
    if (!sender.avatar) {
      return null;
    }
    return sender.avatar && sender.avatar.url;
  }

  private handleCommand(param: {channelId: string; command: string}) {
    if (param.command === 'open' && param.channelId) {
      // for popover
      this.$emit('openChannel', param.channelId);
      // for channel tab
      this.$root.$emit('selectChannel', param.channelId);
    } else if (param.command === 'create') {
      // for popover
      this.$emit('openChannel', 'creation');
      // for channel tab
      this.$root.$emit('selectChannel', 'creation');
    }
  }

  private updateChannelMessage(channelMessage: ChannelMessageFields) {
    const index = this.channelList.findIndex((channel) => {
      return channel.id === channelMessage.channel.id;
    });

    if (index >= 0) {
      this.channelList[index].lastMessage = channelMessage;
    }
  }

  private channelClass(channel: ChannelFields) {
    switch (channel.channelType) {
      case 'private':
        return 'bg-yellow-100';
      case 'partner':
        return 'bg-blue-100';
    }
  }
}
